import styled from "styled-components/macro";
import React, { useEffect, useState, useRef } from "react";

const Back = styled.div`
  position: relative;
  top: 10px;
  right: 20px;
  height: fit-content;
  border-radius: 30px;
  padding: 8px 12px;
  gap: 4px;
  color: #fff;
  border: 1px solid #ffffff;
  cursor: pointer;
`;

const BackToTop = ({ scrollContainerId = "scrollable-container" }) => {
  const [showButton, setShowButton] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const container = document.getElementById(scrollContainerId);
    containerRef.current = container;

    const handleScroll = () => {
      if (container.scrollTop > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [scrollContainerId]);

  const handleBackToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return showButton && <Back onClick={handleBackToTop}>Back To Top ↑</Back>;
};

export default BackToTop;
